import { useEffect } from "react";

/**
 * Sets document.title and the favicon dynamically per page.
 * Falls back to company defaults on unmount.
 */
const COMPANY_ICON =
  "https://customer-assets-agu9un31.emergentagent.net/job_4cb23e94-9099-41ea-90d5-bc25fb08d656/artifacts/gz4wewgq_file%20%282%29.jpg";
const COMPANY_TITLE =
  "Al-Ezdhar & Al-Rafah Trading Ltd. | شركة الإزدهار والرفاه للتجارة المحدودة";

export default function usePageMeta({ title, favicon } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    const prevHref = link.href;
    if (favicon) link.href = favicon;

    let apple = document.querySelector("link[rel='apple-touch-icon']");
    const prevApple = apple ? apple.href : null;
    if (apple && favicon) apple.href = favicon;

    return () => {
      document.title = prevTitle || COMPANY_TITLE;
      if (link) link.href = prevHref || COMPANY_ICON;
      if (apple && prevApple) apple.href = prevApple;
    };
  }, [title, favicon]);
}
